/**
 * errorFilter.js
 *
 * Unterdrückt Cross-Origin "Script error." Meldungen, die durch externe
 * Third-Party-Scripts (z. B. Preview-Overlay assets.emergent.sh) entstehen
 * und iOS Safari damit auf dem Dev-Fehler-Overlay stören.
 *
 * Wird als erstes in index.js importiert (vor React).
 * In Produktion ist der CRA-Overlay nicht aktiv, dieser Filter ist also
 * schadlos.
 */

// „Script error." ist der W3C-standardisierte Placeholder, den Browser für
// Fehler in Cross-Origin-Scripts ohne CORS-Header zurückgeben.
const isCrossOriginScriptError = (message, filename) => {
  if (typeof message !== "string") return false;
  const m = message.trim();
  if (m === "Script error." || m === "Script error") return true;
  // Ohne filename und Zeilenangabe ist es meistens ebenfalls Cross-Origin
  if (!filename && (m === "" || m === "undefined")) return true;
  return false;
};

const isThirdPartyOrigin = (filename) => {
  if (!filename || typeof filename !== "string") return false;
  try {
    const u = new URL(filename, window.location.origin);
    return u.origin !== window.location.origin;
  } catch {
    return false;
  }
};

// Muss VOR react-error-overlay laufen -> capture=true
window.addEventListener(
  "error",
  (e) => {
    if (
      isCrossOriginScriptError(e.message, e.filename) ||
      isThirdPartyOrigin(e.filename)
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
    return undefined;
  },
  true,
);

window.addEventListener(
  "unhandledrejection",
  (e) => {
    const r = e?.reason;
    const msg = typeof r === "string" ? r : r?.message || "";
    if (
      isCrossOriginScriptError(msg, r?.filename) ||
      // In Safari kann eine abgebrochene navigator.share/ähnliche
      // AbortError produzieren – die ist funktional erwartet.
      r?.name === "AbortError"
    ) {
      e.preventDefault();
    }
  },
  true,
);

// Für ältere Fallbacks: window.onerror-Chain freundlich halten
const origOnError = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (isCrossOriginScriptError(String(message), source) || isThirdPartyOrigin(source)) {
    return true;
  }
  if (typeof origOnError === "function") {
    return origOnError.apply(this, arguments);
  }
  return false;
};
